import React from 'react';
const cc = require('../ClassComposer');

export default class SVGIcon extends React.Component {

    /**
     *
     * @return {*}
     */
    render() {
        const {identifier, addClass, ..._rest} = this.props;
        let versionQuery = '?v=66';
        // const environment = getApp().getEnvironment();
        //
        // let versionQuery = '';
        //
        // if (environment) {
        //     const {icons} = environment.getFileVersions();
        //
        //     versionQuery = '?v=' + icons;
        // }

        const className = cc('rs-icon', {
            ['rs-icon-' + identifier]: (identifier)
        }, addClass);

        return (
            <svg className={className} {..._rest}>
                <use xlinkHref={'/static/icons/icons.svg' + versionQuery + '#' + identifier }/>
            </svg>
        )
    }
}

SVGIcon.propTypes = {
    identifier: React.PropTypes.string.isRequired,
    addClass: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/SVGIcon.jsx